import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function AvisoLegal() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-32 md:py-40">

        <div className="mb-14">
          <span className="text-[#c9a96e] text-[10px] uppercase tracking-[0.3em] font-semibold" style={{ fontFamily: "'Manrope', sans-serif" }}>
            Legal
          </span>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight mt-4 text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Aviso Legal
          </h1>
          <div className="w-12 h-[2px] bg-[#c9a96e] mt-6" />
        </div>

        <div className="space-y-10 text-[#f8f6f3]/60 text-sm leading-[1.9]" style={{ fontFamily: "'Manrope', sans-serif" }}>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>1. Datos identificativos del titular</h2>
            <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se ponen a disposición del usuario los siguientes datos identificativos:</p>
            <ul className="space-y-1 pl-4 border-l-2 border-[#c9a96e]/30">
              <li><strong>Denominación social:</strong> A.F. Puertos, S.L.</li>
              <li><strong>CIF:</strong> B29860566</li>
              <li><strong>Domicilio social:</strong> Calle Gerald Brenan, 39, 1B, 29120 Alhaurín el Grande, Málaga</li>
              <li><strong>Teléfono:</strong> 952 490 400</li>
              <li><strong>Correo electrónico:</strong> info@afpuertos.com</li>
              <li><strong>Actividad:</strong> Asesoría fiscal, laboral, contable y jurídica</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>2. Objeto y ámbito de aplicación</h2>
            <p>El presente Aviso Legal regula el acceso y uso del sitio web <strong>afpuertos.es</strong> (en adelante, "el Sitio Web"), cuyo titular es A.F. Puertos, S.L. El acceso al Sitio Web implica la aceptación plena y sin reservas de todas las disposiciones incluidas en este Aviso Legal. A.F. Puertos, S.L. se reserva el derecho a modificar el presente aviso legal en cualquier momento.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>3. Propiedad intelectual e industrial</h2>
            <p>Todos los contenidos del Sitio Web —incluyendo, sin carácter limitativo, textos, fotografías, gráficos, logotipos, iconos, imágenes, marcas y nombres comerciales— son propiedad de A.F. Puertos, S.L. o de terceros que han autorizado su uso, y están protegidos por la normativa española e internacional sobre propiedad intelectual e industrial.</p>
            <p>Queda expresamente prohibida la reproducción, distribución, comunicación pública o transformación de cualquier contenido del Sitio Web sin la autorización expresa y por escrito de A.F. Puertos, S.L.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>4. Exclusión de responsabilidad</h2>
            <p>A.F. Puertos, S.L. no se hace responsable de los daños y perjuicios de cualquier naturaleza que pudieran derivarse del acceso o uso del Sitio Web, ni de la información contenida en el mismo, incluidos los fallos técnicos o de seguridad que pudieran producirse. La información publicada tiene carácter meramente orientativo y no sustituye el asesoramiento profesional personalizado.</p>
            <p>A.F. Puertos, S.L. no garantiza la disponibilidad continua del Sitio Web y podrá suspender, modificar o cancelar el acceso al mismo en cualquier momento sin previo aviso.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>5. Política de enlaces</h2>
            <p>El Sitio Web puede contener enlaces a páginas web de terceros. A.F. Puertos, S.L. no tiene control sobre dichos sitios ni se responsabiliza de sus contenidos, políticas de privacidad o prácticas. La inclusión de cualquier enlace no implica aprobación ni asociación con el sitio enlazado.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>6. Ley aplicable y jurisdicción</h2>
            <p>El presente Aviso Legal se rige por la legislación española vigente. Para la resolución de cualquier controversia derivada del acceso o uso del Sitio Web, las partes se someten, con renuncia expresa a cualquier otro fuero que pudiera corresponderles, a los Juzgados y Tribunales de Málaga.</p>
          </section>

          <p className="text-xs text-[#f8f6f3]/30 pt-6 border-t border-[#f8f6f3]/10">Última actualización: marzo de 2026</p>
        </div>

      </main>
      <Footer />
    </div>
  );
}
